import { render, staticRenderFns } from "./StyleCardVertical.vue?vue&type=template&id=17378010"
import script from "./StyleCardVertical.vue?vue&type=script&lang=js"
export * from "./StyleCardVertical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17378010')) {
      api.createRecord('17378010', component.options)
    } else {
      api.reload('17378010', component.options)
    }
    module.hot.accept("./StyleCardVertical.vue?vue&type=template&id=17378010", function () {
      api.rerender('17378010', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "static/js/components-wa/StyleCard/StyleCardVertical.vue"
export default component.exports